import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const scrollYRef = useRef(0);

    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => setMenuOpen((prev) => !prev);
    const closeMenu = () => setMenuOpen(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 30);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const body = document.body;

        if (menuOpen) {
            scrollYRef.current = window.scrollY;
            body.style.position = 'fixed';
            body.style.top = `-${scrollYRef.current}px`;
            body.style.left = '0';
            body.style.right = '0';
            body.style.width = '100%';
            body.style.overflow = 'hidden';
        } else {
            const savedScroll = scrollYRef.current;

            body.style.position = '';
            body.style.top = '';
            body.style.left = '';
            body.style.right = '';
            body.style.width = '';
            body.style.overflow = '';

            window.scrollTo(0, savedScroll);
        }

        return () => {
            body.style.position = '';
            body.style.top = '';
            body.style.left = '';
            body.style.right = '';
            body.style.width = '';
            body.style.overflow = '';
        };
    }, [menuOpen]);

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const handleLinkClick = (e, id) => {
        e.preventDefault();
        closeMenu();

        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                scrollToSection(id);
            }, 450);
        } else {
            setTimeout(() => {
                scrollToSection(id);
            }, 100);
        }
    };

    return (
        <>
            <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
                <div className="navbar-container">
                    <div
                        className="navbar-logo"
                        onClick={(e) => handleLinkClick(e, 'hero')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleLinkClick(e, 'hero');
                            }
                        }}
                    >
                        <img src="/images/logo-kyra.png" alt="Logo Kyra Renov" />
                        <div className="navbar-brand-text">
                            <span className="brand-title">Kyra Renov</span>
                            <span className="brand-subtitle">Rénovation intérieure et extérieur</span>
                        </div>
                    </div>

                    <nav className="navbar-links">
                        <a href="#hero" onClick={(e) => handleLinkClick(e, 'hero')}>Accueil</a>
                        <a href="#about" onClick={(e) => handleLinkClick(e, 'about')}>À propos</a>
                        <a href="#realisations" onClick={(e) => handleLinkClick(e, 'realisations')}>Réalisations</a>
                        <a
                            href="#avant-apres"
                            onClick={(e) =>
                                handleLinkClick(e, "avant-apres")
                            }
                        >
                            Avant / Après
                        </a>
                        <a href="#services" onClick={(e) => handleLinkClick(e, 'services')}>Services</a>
                        <a href="#whychooseus" onClick={(e) => handleLinkClick(e, 'whychooseus')}>Pourquoi nous</a>
                        <a href="#contact" onClick={(e) => handleLinkClick(e, 'contact')}>Contact</a>
                    </nav>

                    <a
                        href="#contact"
                        className="navbar-cta"
                        onClick={(e) => handleLinkClick(e, 'contact')}
                    >
                        Devis
                    </a>

                    <button
                        className={`burger ${menuOpen ? "open" : ""}`}
                        onClick={toggleMenu}
                        aria-label={
                            menuOpen
                                ? "Fermer le menu"
                                : "Ouvrir le menu"
                        }
                        aria-expanded={menuOpen}
                        type="button"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </header>
            <nav
                className={`mobile-menu ${menuOpen ? "active" : ""}`}
                aria-hidden={!menuOpen}
            >
                <button
                    type="button"
                    className="mobile-menu-close"
                    onClick={closeMenu}
                    aria-label="Fermer le menu"
                >
                    <span></span>
                    <span></span>
                </button>

                <div className="mobile-menu-inner">
                    <a href="#hero" onClick={(e) => handleLinkClick(e, 'hero')}>Accueil</a>
                    <a href="#about" onClick={(e) => handleLinkClick(e, 'about')}>À propos</a>
                    <a href="#realisations" onClick={(e) => handleLinkClick(e, 'realisations')}>Réalisations</a>
                    <a
                        href="#avant-apres"
                        onClick={(e) =>
                            handleLinkClick(e, "avant-apres")
                        }
                    >
                        Avant / Après
                    </a>
                    <a href="#services" onClick={(e) => handleLinkClick(e, 'services')}>Services</a>
                    <a href="#whychooseus" onClick={(e) => handleLinkClick(e, 'whychooseus')}>Pourquoi nous</a>
                    <a href="#contact" onClick={(e) => handleLinkClick(e, 'contact')}>Contact</a>

                    <a
                        href="#contact"
                        className="mobile-menu-cta"
                        onClick={(e) => handleLinkClick(e, 'contact')}
                    >
                        Demander un devis
                    </a>
                </div>
            </nav>

            {menuOpen && <div className="overlay" onClick={closeMenu}></div>}
        </>
    );
}